import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
// import useMediaQuery from '@mui/material/useMediaQuery';
import OutsideClickHandler from "react-outside-click-handler";
import logo from "../../assets/img/aadi-login-logo.png";
import aaysLogo from "../../assets/img/Aays.png";
import Logout from "../auth/Logout";

import "./TopNavBar.scss";
import { FaCogs } from "react-icons/fa";
import Getusers from "../auth/Getusers";
import { Link } from "react-router-dom";
const drawerWidth = 300;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100%)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
  ...(!open && {
    marginLeft: drawerWidth,
    width: `calc(100%)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Topnavbar = (props) => {
  // const theme = useTheme();
  // const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [openDialog, setopenDialog] = useState(false);
  // const [openDialogq1, setopenDialog1] = useState(false);

  return (
    <>
      <Box sx={{ display: "flex" }}>
        <AppBar
          position="fixed"
          style={{ backgroundColor: "white", boxShadow: "none", zIndex: "1" }}
          open={props.open}
        >
          <Toolbar
            className="navBarStyle"
            style={{
              justifyContent: "space-between",
              alignItems: "center",
              height: "80px",
              paddingLeft:"105px"
            }}
          >
            <Typography
              variant="h6"
              style={{
                color: "#1453A0",
                fontSize: "28px",
                fontWeight: "700",
                width: "100%",
                textAlign: "left",
              }}
              noWrap
              component="div"
              className="navBarStyleColor"
            >
              <div className="navbar-container">
                <div className="logo-container">
                  <img width={80} src={logo} alt="Aays LOGO" />
                </div>

                {/* <h3 className="navbar-heading">
                  Aays Data Flow System
                </h3> */}

                <div className="right-side-container">
                 
           
            
                 
                 
      

                  <div className="info-container">
                    <div className="main-info">
                      <p>
                        <Getusers name={true} />
                      </p>
                      <p className="info-profile"> <Getusers email={true} /></p>
                    </div>
                    <div className="info-initials">
                      <Getusers trim={true} />
                    </div>
                  </div>
                </div>
              </div>
            </Typography>
          </Toolbar>
        </AppBar>
      </Box>
    </>
  );
};

export default Topnavbar;
